import * as React from "react";
import { MyAccountService } from "./myaccount-service";
import { dialogService } from "react-api-dialog";
import t from "../i18n";
import { confirmDialog } from "../dialogs/ConfirmDialog";
import Img from "../Controls/Img";
import { StoredCreditCard } from "../types";
import { cardStyles } from "../_styles/receiptcard";
import { css } from "emotion";
import classNames from "classnames";

declare type CardBlockProps = {
  creditCard: StoredCreditCard;
  onDeleted?: () => void;
};
declare type CardBlockState = {
  isDeleted: boolean;
};

export default class StoredCardBlock extends React.Component<CardBlockProps, CardBlockState> {
  readonly state: CardBlockState = { isDeleted: false };
  deleteStoredCard = async () => {
    const canCancel = await confirmDialog(
      t.myaccount("delete_stored-card-message"),
      t.menu("stored-cards"),
      t.common("ok_button"),
      t.common("cancel_button")
    );
    if (canCancel.cancelled) {
      return;
    }
    dialogService.showPreloader();
    const response = await MyAccountService.deleteStoredCard(this.props.creditCard.creditCardId);
    await dialogService.hidePreloader();
    if (!response) return;
    if (response.responseCode == 0) {
      this.setState({ isDeleted: true });
    }
    if (this.props.onDeleted) this.props.onDeleted();
  };
  render() {
    if (this.state.isDeleted) return null;
    return (
      <div className="form-group col-sm-6">
        <div className={classNames(["receipt-card", css(cardStyles.white)])}>
          <div className="d-flex align-items-center justify-content-between">
            <div style={{ lineHeight: 1.3 }}>
              <div>
                <Img src={`/images/${this.props.creditCard.cardType}.svg`} style={{ width: 32, marginRight: 10 }} />
                <span className="font-weight-500">{this.props.creditCard.creditCardNumber}</span>
              </div>
              <div style={{ marginTop: "10px" }}>
                {t.topup("expiration_date_placeholder")}: {this.props.creditCard.expiryMonthyear}
              </div>
            </div>
          </div>
          <hr />
          {
            <div className="font-italic font-weight-500 d-flex align-items-center justify-content-end">
              <React.Fragment>
                <div style={{ width: 10 }} />
                {!this.props.creditCard.isUsedForRecurringProfile ? (
                  <a href="javascript:void(0)" onClick={this.deleteStoredCard}>
                    {t.common("remove")}{" "}
                  </a>
                ) : (
                  <a>{t.common("remove")} </a>
                )}
              </React.Fragment>
            </div>
          }
        </div>
      </div>
    );
  }
}
